import { AuditRequirementResponse, RequirementPageType } from '@shared/types'

import { useQuery } from 'react-query'

import { apiJSON } from '@shared/utils/api/api.util'

export const useRequirementQuery = (
  type: RequirementPageType,
  companyID: string,
  auditID?: string,
  requirementID?: string
) => {
  const {
    data: requirement,
    isLoading: isLoadingRequirement,
    refetch: refetchRequirement,
  } = useQuery<AuditRequirementResponse>(
    `companies/${companyID}/audits/${auditID}/requirements/${requirementID}`,
    () =>
      apiJSON(
        `companies/${companyID}/audits/${auditID}/requirements/${requirementID}`
      ),
    {
      enabled:
        type === 'assessment' && !!companyID && !!auditID && !!requirementID,
    }
  )

  const {
    data: publishedRequirement,
    isLoading: isLoadingPublishedRequirement,
    refetch: refetchPublishedRequirement,
  } = useQuery<AuditRequirementResponse>(
    `companies/${companyID}/publishedAuditRequirements/${requirementID}`,
    () =>
      apiJSON(
        `companies/${companyID}/publishedAuditRequirements/${requirementID}`
      ),
    {
      enabled: type === 'published' && !!companyID && !!requirementID,
    }
  )

  const {
    data: esqulaRequirement,
    isLoading: isLoadingEsqulaRequirement,
    refetch: refetchEsqulaRequirement,
  } = useQuery<AuditRequirementResponse>(
    `companies/${companyID}/esqularequirements/${requirementID}`,
    () => apiJSON(`companies/${companyID}/esqularequirements/${requirementID}`),
    {
      enabled: type === 'esqula' && !!companyID && !!requirementID,
    }
  )

  return {
    requirement: requirement || publishedRequirement || esqulaRequirement,
    isLoading:
      isLoadingRequirement ||
      isLoadingPublishedRequirement ||
      isLoadingEsqulaRequirement,
  }
}
